import { useQuery } from "@tanstack/react-query";
import type { SellerOrderDetail } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { queryKeys } from "@/lib/query/core/query-keys";

type UseSellerOrderByIdQueryParams = {
  storeSlug: string;
  orderId: string;
};

export function useOrderByIdQuery({
  storeSlug,
  orderId,
}: UseSellerOrderByIdQueryParams) {
  const query = useQuery({
    queryKey: queryKeys.seller.orderById(storeSlug, orderId),
    queryFn: () => apiJsonClient<SellerOrderDetail>(endpoints.seller.orderById(orderId)),
    enabled: storeSlug.length > 0 && orderId.length > 0,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
